import React, { useState } from 'react'
import DataGridAlternativa from '../../../../components/DataGridAlternativa'
import { Visualizar } from '../../../../components/Acoes'

const Consulta = props => {
    const [data, setData] = useState([])


    const columns = React.useMemo(
        () => [{
            id: 'consulta-cooperado-pj',
            columns: [
                {
                    Header: 'Código',
                    accessor: 'id',
                    ordenamento: {
                        tipo: 'numero',
                        ativo: true,
                        modo: 'desc',
                    }
                }
                , {
                    Header: 'Matrícula',
                    accessor: 'maco_id',
                    ordenamento: {
                        tipo: 'numero'
                    }
                },
                {
                    Header: 'Razão Social',
                    accessor: 'copj_razao_social',
                    ordenamento: {
                        tipo: 'texto'
                    }
                },
                {
                    Header: 'Nome Fantasia',
                    accessor: 'copj_nome_fantasia',
                    ordenamento: {
                        tipo: 'texto'
                    }
                },
                {
                    Header: 'CNPJ',
                    accessor: 'copj_cnpj',
                    ordenamento: {
                        tipo: 'texto'
                    }
                },
                {
                    Header: 'Conselho',
                    accessor: 'conselho',
                    visivel: false,
                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'conselho_profissional',
                        idColuna: 'conselho_profissional.copr_id'
                    }
                },
                {
                    Header: 'CBOS',
                    accessor: 'cbos_descricao',
                    visivel: false,
                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'cbos',
                        idColuna: 'cbos.cbos_id'
                    }
                },
                {
                    Header: 'Situação Administrativa',
                    accessor: 'siad_descricao',
                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'situacao_administrativa',
                        idColuna: 'siad_id'
                    }
                },
                {
                    Header: 'Data Situação',
                    accessor: 'csad_data_situacao',
                    ordenamento: {
                        tipo: 'data'
                    }
                }
            ]
        }], []
    )

    const maisAcoesObj = [
        (propsAcao) => <Visualizar to={'/faturamento/cooperadopj/visualizacao/' + propsAcao.id} />
    ]

    return (
        <>
            <div>
                <DataGridAlternativa acoesObj={maisAcoesObj} data={data} columns={columns} setData={setData} acoes={true} caminhoBase='/faturamento/cooperadopj' caminhoConsultaFiltros='/faturamento/cooperadopjpaginacao' modulo={props.modulo} titulo={'Consulta Cooperado PJ'}
                    tituloLista={'Lista Cooperado PJ'} icone={props.icone} />
            </div>
        </>
    )
}

export default Consulta